'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.requiredOnboardingMerchIdSelector = exports.requiredOnboardingSelector = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _Mon153WaivedOnboardingSelectors = require('pricing-pages-unified-ui/selectors/Mon153WaivedOnboardingSelectors');

var _MerchandiseIds = require('self-service-api/constants/MerchandiseIds');

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var requiredOnboardingSelector = exports.requiredOnboardingSelector = function requiredOnboardingSelector(state) {
  var requiredOnboarding = state.requiredOnboarding;


  if ((0, _Mon153WaivedOnboardingSelectors.shouldWaiveSalesProOnboardingMon153Selector)(state)) {
    return _extends({}, requiredOnboarding, _defineProperty({}, _MerchandiseIds.PRODUCT_SALES_PROFESSIONAL, undefined));
  }

  return requiredOnboarding;
};

var requiredOnboardingMerchIdSelector = exports.requiredOnboardingMerchIdSelector = function requiredOnboardingMerchIdSelector(state, merchId) {
  var requiredOnboarding = requiredOnboardingSelector(state);
  return requiredOnboarding[merchId] && requiredOnboarding[merchId].onboardingMerchandiseId;
};


//////////////////
// WEBPACK FOOTER
// ./js/selectors/RequiredOnboardingSelectors.js
// module id = 233
// module chunks = 3 4 5